import { useTheme } from '@material-ui/core/styles';

const ICON_SIZE = 35;

export const ArgoFeaturePreviewIcon = () => {
  const theme = useTheme();
  const src =
    theme.palette.type === 'dark' ? '/argo-prev-dark.png' : '/argo-prev.png';

  return (
    <img
      src={src}
      alt="ArgoFeaturePrev"
      width={ICON_SIZE}
      height={ICON_SIZE}
      style={{ display: 'block' }}
    />
  );
};
